<template>
  <div class="bg-white ">
    <lcontainer class="mb-4">
      <div
        class="heading  px-8 py-2 flex flex-row items-center justify-between"
      >
        <div>
          <div class="page text-white">Coupon</div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <lCrumbs class=" px-8" :breadcrumb="breadcrumbItems" />
    <div class=" px-8 py-4 modal-title tenant-main-color font-semibold mb-2">
      Create a new Coupon
    </div>

    <div class="flex flex-wrap">
      <div class="flex  px-8 py-4 flex-row w-full md:w-1/2">
        <div class="flex flex-col flex-grow items-start justify-between mr-12">
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold mr-2">Code:</div>
            <div class="flex-grow ml-auto">
              <linput
                type="text"
                name="fname"
                v-model="form.coupon_code"
                :errorMessage="errors.coupon_code"
                :error="errors.coupon_code"
                placeholder="Enter Coupon Code here:"
              />
            </div>
          </div>
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold">Discount Type:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.discount_type"
                v-model="form.discount_type"
                :errorMessage="errors.discount_type"
                :items="type"
                placeholder="Select Discount Type"
              />
            </div>
          </div>
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold">Usage Type:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.usage_type"
                v-model="form.usage_type"
                :errorMessage="errors.usage_type"
                :items="usage"
                placeholder="Select Discount Type"
              />
            </div>
          </div>
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold mr-2">Discount Value:</div>
            <div class="flex-grow ml-auto">
              <linput
                type="text"
                name="fname"
                v-model="form.discount_value"
                :errorMessage="errors.discount_value"
                :error="errors.discount_value"
                placeholder="Enter Discount Value here:"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex  px-8 py-4 flex-row w-full md:w-1/2">
        <div class="flex flex-col flex-grow items-start mr-12">
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold">Coupon Type:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.coupon_type"
                v-model="form.coupon_type"
                :errorMessage="errors.coupon_type"
                :items="coupon"
                placeholder="Select Coupon Type"
              />
            </div>
          </div>
          <div class="flex flex-row items-center form-row mb-8">
            <div class="modal-field font-semibold mr-2">Usage Limit:</div>
            <div class="flex-grow ml-auto">
              <linput
                type="text"
                name="fname"
                v-model="form.usage_limit"
                :errorMessage="errors.usage_limit"
                :error="errors.usage_limit"
                placeholder="e.g 200"
              />
            </div>
          </div>

          <div
            v-if="form.usage_type === 'per_user'"
            class="flex flex-row items-center form-row mb-8"
          >
            <div class="modal-field font-semibold">Select User:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.user"
                v-model="form.user"
                :errorMessage="errors.user"
                :items="sortUsers"
                placeholder="Select User"
              />
            </div>
          </div>

          <div
            v-if="form.coupon_type === 'course'"
            class="flex flex-row items-center form-row mb-8"
          >
            <div class="modal-field font-semibold">Select Course:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.target_id"
                v-model="form.target_id"
                :errorMessage="errors.target_id"
                :items="sortCourses"
                placeholder="Select Coupon Target"
              />
            </div>
          </div>

          <div
            v-if="form.coupon_type === 'program'"
            class="flex flex-row items-center form-row mb-8"
          >
            <div class="modal-field font-semibold">Select Program:</div>
            <div class="flex-grow ml-auto">
              <lselect
                :error="errors.target_id"
                v-model="form.target_id"
                :errorMessage="errors.target_id"
                :items="sortPrograms"
                placeholder="Select Coupon Target"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-center items-center">
      <div class="mb-2">
        <lms-button @click="handleFormSubmit">Submit</lms-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      id: "",
      allUsers: [],
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/coupon",
          text: "All Coupons",
        },
        {
          disabled: true,
          to: "#",
          text: "Edit Coupon ",
        },
      ],
      type: [
        {
          text: "Fixed",
          value: "fixed",
        },
        {
          text: "Percentage",
          value: "percentage",
        },
      ],
      coupon: [
        {
          text: "Course",
          value: "course",
        },
        {
          text: "Program",
          value: "program",
        },
        {
          text: "Cart",
          value: "cart",
        },
      ],
      usage: [
        {
          text: "Per User",
          value: "per_user",
        },
        {
          text: "Per All",
          value: "per_all",
        },
      ],
      errors: [],
      form: {},
    };
  },
  computed: {
    ...mapGetters(["getTenantCourses", "getTenantPrograms"]),
    sortCourses() {
      let courses = this.getTenantCourses;
      if (!courses) return [];
      let data = [];
      courses.forEach((course) => {
        let obj = {};
        obj.text = course.title;
        obj.value = course.id;
        data.push(obj);
      });
      return data;
    },
    sortPrograms() {
      let programs = this.getTenantPrograms;
      if (!programs) return [];
      let data = [];
      programs.forEach((program) => {
        let obj = {};
        obj.text = program.title;
        obj.value = program.id;
        data.push(obj);
      });
      return data;
    },
    sortUsers() {
      let users = this.allUsers;
      if (!users) return [];
      let data = [];
      users.forEach((user) => {
        let obj = {};
        obj.text = user.name;
        obj.value = user.id;
        data.push(obj);
      });
      return data;
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
    lcontainer: () => import("@/components/general/container"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  async mounted() {
    this.updateLoader(true);
    this.form = await this.tenantFetchCourseCoupon({
      id: this.$route.params.id,
    });
    this.fetchTenantPrograms();
    this.allUsers = await this.tenantListUsers();
    this.updateLoader(false);
  },
  methods: {
    ...mapActions([
      "tenantFetchCourseCoupon",
      "tenantUpdateCoupon",
      "fetchTenantPrograms",
      "tenantListUsers",
    ]),
    ...mapMutations(["updateLoader"]),
    async handleFormSubmit() {
      this.errors = [];
      this.updateLoader(true);
      let res = await this.tenantUpdateCoupon(this.form);
      this.updateLoader(false);
      if (res == true || res.status == 200 || res.status == 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Coupon updated successfully",
        });
        this.$router.replace({ name: "tenant-coupon-home" });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-admin);
    }

    .modal-field {
      color: color(lms-admin);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: -17px;
      z-index: 2;
      right: -16px;
    }
    z-index: 1;
  }
}
</style>
